import { APISettings } from '../config.js';
import loginMethods from '../resources/loginMethods.js'

export default {
    name: "systemMethods",

    async getSystems() {
        //console.log("Starting request");
        try {
            const response = await fetch("/backend/systems", {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async getConditions(id) {
        try {
            const response = await fetch("/backend/conditions/" + id, {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postConditions(obj) {
        try {
            const response = await fetch("/backend/conditions", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async removeConditions(obj) {
        try {
            const response = await fetch("/backend/conditions", {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async calculate(obj) {
        try {
            const response = await fetch("/backend/calculate/", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }
            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            /*             data.data.forEach((product) => {
                            product.variations.forEach((variation) => {
                                variation.active = true;
                            })
                        }) */
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postSystem(obj) {
        try {
            const response = await fetch("/backend/systems", {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async deleteSystem(obj) {
        try {
            const response = await fetch("/backend/systems", {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async yieldOverrideRules(id = "") {
        try {
            const response = await fetch("/backend/yieldOverride/" + id, {
                method: 'GET',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                }
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
    async postYieldRule(obj) {
        try {
            const response = await fetch("/backend/yieldOverride/"+obj.id, {
                method: 'POST',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    },
        async deleteYieldRule(obj) {
        try {
            const response = await fetch("/backend/yieldOverride/"+obj.id, {
                method: 'DELETE',
                headers: {
                    'Authorization': localStorage.getItem("jwt")
                },
                body: JSON.stringify(obj)
            });
            if (!response.ok) {
                if (response.status === 401) {
                    loginMethods.logout();
                }
                //console.log("Finished request with failure");
                return false;
            }

            //console.log("Finished request successfully");
            APISettings.refreshJwt(response.headers.get('Authorization'));
            const data = await response.json();
            return data; // This ensures the state is updated
        } catch (err) {
            console.error("Error during getSystem request:", err);
        }
    }
}